'use strict';

var mcb = mcb || {};

// Document ready
document.addEventListener('DOMContentLoaded', () => {
    mcb.object.utils.init();
    mcb.navigation.init();
    mcb.lazyLoad.init();
    mcb.accordion.init();
    mcb.newswheel.init();
    mcb.mobilenavigation.init();
    mcb.video.init();
    mcb.tooltip.init();
    mcb.scrollto.init();
    mcb.matomodatalayer.init();
    mcb.listgroupitem.init();
    mcb.url.utils.init();
});